import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";

const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});

export const fetchAllLabels = (restaurantID) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const labelsSnapshot = await firebase
        .firestore()
        .collection("labels")
        .where("restaurantID", "in", [restaurantID, "null"])
        .get();

      const labels = labelsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch({
        type: "FETCH_ALL_LABELS_SUCCESS",
        payload: labels,
      });
      resolve(labels);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};

export const getLabels =
  (id, search, hitsPerPage, currentPage, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const index = client.initIndex("labels");
      const response = await index.search(search, {
        filters: `restaurantID:${id} OR restaurantID:${null}`,
        hitsPerPage,
        page: currentPage,
      });

      const { hits, ...rest } = response;

      dispatch({
        type: "FETCH_LABELS_SUCCESS",
        payload: {
          hits,
          rest,
        },
      });
    } catch (error) {
      console.error("Error fetching labels:", error);
    }
  };

export const addLabel =
  (payload, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    try {
      const labelRef = firebase.firestore().collection("labels").doc();
      const docId = labelRef.id;

      const imageFile = payload?.labelURL;
      let downloadURL = "";

      if (imageFile) {
        const fileName = imageFile.name;
        const storageRef = firebase
          .storage()
          .ref(`labels/${docId}/${fileName}`);
        const uploadTaskSnapshot = await storageRef.put(imageFile);
        downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();
      }

      await labelRef.set({
        ...payload,
        labelURL: downloadURL,
        createdAt: firebase.firestore.Timestamp.now(),
        updatedAt: firebase.firestore.Timestamp.now(),
      });
      onSuccess();
    } catch (error) {
      onError();
      toast.error("Failed to add label: " + error.message);
      console.error("Error adding label:", error);
    }
  };

export const editLabel =
  (id, payload, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    try {
      const labelRef = firebase.firestore().collection("labels").doc(id);

      const imageFile = payload?.labelURL;
      if (imageFile instanceof File) {
        const previousImagePath = `labels/${id}`;
        const previousImageRef = firebase.storage().ref(previousImagePath);
        if (previousImageRef) {
          const files = await previousImageRef.listAll();
          const deletePromises = files.items.map((fileRef) => fileRef.delete());
          await Promise.all(deletePromises).catch((error) => {
            console.error("Error deleting previous images:", error);
          });
        }

        const fileName = imageFile.name;
        const storageRef = firebase
          .storage()
          .ref(`${previousImagePath}/${fileName}`);
        const uploadTaskSnapshot = await storageRef.put(imageFile);
        const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();

        payload.labelURL = downloadURL;
      }

      await labelRef.update({
        ...payload,
        updatedAt: firebase.firestore.Timestamp.now(),
      });
      onSuccess();
    } catch (error) {
      onError();
      console.error("Error updating label:", error);
      toast.error("Error updating label");
    }
  };

export const deleteLabel =
  (id, imageUrl, onSuccess = () => {}, onError = () => {}) =>
  async (dispatch) => {
    try {
      if (imageUrl) {
        const storageRef = firebase.storage().refFromURL(imageUrl);
        await storageRef.delete();
      }

      await firebase.firestore().collection("labels").doc(id).delete();

      onSuccess();
    } catch (error) {
      onError();
      console.error("Error deleting label:", error);
      toast.error(error.message || "Unable to delete label");
    }
  };
